import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { get, post } from "../../api/api";

export const executarValidacaoIqvia = async (payload: any) => {
  return await post<IRespostaFuncao<any>>('/validacao-relatorios-iqvia/executar-consulta', payload);
};

export const buscaConsultasIqvia = async (payload: any) => {
  return await get<IRespostaFuncao<any>>('/consultas-relatorios-iqvia/obtem-consultas-iqvia', payload);
};

